import styled from '@emotion/styled';
import { Content, Portal, Provider, Root, Trigger } from '@radix-ui/react-tooltip';

import type { TooltipProps } from '@radix-ui/react-tooltip';
import type { FunctionComponent } from 'react';

const StyledContent = styled(Content)(({ theme }) => ({
    backgroundColor: theme.colors.gray[900],
    borderRadius: theme.borderRadius.s,
    boxShadow: theme.shadows.medium,
    color: theme.colors.white[200],
    fontSize: theme.typography.body.XS.regular.fontSize,
    fontWeight: theme.typography.body.XS.regular.fontWeight,
    lineHeight: theme.typography.body.XS.regular.lineHeight,
    maxWidth: '300px',
    padding: `${theme.spacing.xs} ${theme.spacing.s}`,
    zIndex: 1001,
}));

export const Tooltip: FunctionComponent<TooltipProps> & {
    // eslint-disable-next-line functional/prefer-readonly-type
    Content: typeof StyledContent;
    // eslint-disable-next-line functional/prefer-readonly-type
    Portal: typeof Portal;
    // eslint-disable-next-line functional/prefer-readonly-type
    Provider: typeof Provider;
    // eslint-disable-next-line functional/prefer-readonly-type
    Root: typeof Root;
    // eslint-disable-next-line functional/prefer-readonly-type
    Trigger: typeof Trigger;
} = ({ children, delayDuration = 200, ...props }) => {
    return (
        <Provider delayDuration={delayDuration}>
            <Root {...props}>{children}</Root>
        </Provider>
    );
};

Tooltip.Provider = Provider;
Tooltip.Root = Root;
Tooltip.Trigger = Trigger;
Tooltip.Content = StyledContent;
Tooltip.Portal = Portal;
